import { render } from "./load.vue?vue&type=template&id=a5291fd8"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"

import "./load.vue?vue&type=style&index=0&id=a5291fd8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__